export function fmtAccountingSnapshotValue(label, value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return String(value ?? '');
  }

  switch (label) {
    case 'Monthly OPEX':
    case 'Begin cash':
    case 'Total assets':
    case 'Total liabilities':
    case 'SAFE':
    case 'Debt':
      return `$${Math.round(n).toLocaleString('en-US')}`;
    case 'GPM (%)':
      return `${formatPercentValue(n, 2)}%`;
    case 'Revenue growth YoY (%)':
      return `${formatPercentValue(n, 1)}%`;
    case 'Runway (months)':
      return formatDecimalValue(n, 1);
    default:
      return formatDecimalValue(n, 2);
  }
}

function formatPercentValue(value, fractionDigits = 1) {
  const factor = 10 ** fractionDigits;
  const rounded = Math.round(value * factor) / factor;
  return rounded.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

function formatDecimalValue(value, maxFractionDigits) {
  if (Math.abs(value - Math.round(value)) < 0.001) {
    return Math.round(value).toLocaleString('en-US');
  }
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
  });
}

export function formatExtractElapsed(startedAt) {
  if (!startedAt) {
    return null;
  }
  const started = new Date(startedAt);
  if (Number.isNaN(started.getTime())) {
    return null;
  }
  const seconds = Math.max(0, Math.floor((Date.now() - started.getTime()) / 1000));
  if (seconds < 60) {
    return `${seconds}s`;
  }
  const minutes = Math.floor(seconds / 60);
  const rem = seconds % 60;
  return `${minutes}m ${rem}s`;
}
